import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface DateFormatResult {
  inputFormat: 'MM/DD/YYYY' | 'DD/MM/YYYY';
  shortMonthFormat: 'MMM dd, yyyy' | 'dd MMM yyyy';
  longMonthFormat: 'MMMM dd, yyyy' | 'dd MMMM yyyy';
  defaultFormat: 'MMM dd, yyyy' | 'dd MMM yyyy';
}

export const useDateFormat = (): DateFormatResult => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const isUS = i18n.language === 'en-US';

    if (isUS) {
      return {
        inputFormat: 'MM/DD/YYYY',
        shortMonthFormat: 'MMM dd, yyyy',
        longMonthFormat: 'MMMM dd, yyyy',
        defaultFormat: 'MMM dd, yyyy',
      };
    }

    return {
      inputFormat: 'DD/MM/YYYY',
      shortMonthFormat: 'dd MMM yyyy',
      longMonthFormat: 'dd MMMM yyyy',
      defaultFormat: 'dd MMM yyyy',
    };
  }, [i18n.language]);
};
